import { defineStore } from 'pinia';
import axios from 'axios';

export const useFollowUpAccessStore = defineStore('followUpAccess', {
  state: () => ({ permissions: {} }),
  getters: {
    can: state => permission => state.permissions[permission] === true,
  },
  actions: {
    async fetch() {
      try {
        const { data } = await axios.get('/follow-up-permissions');
        this.permissions = data.data;
      } catch (error) {
        this.permissions = {};
        throw error;
      }
    },
  },
});
